/** @format */

import React from 'react';
import KeyForm from '../KeyForm';

export default function KeyNew() {
  return <KeyForm />;
}
